import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/** Largura e respiro padrão de TODAS as páginas internas (desktop e mobile).
 *  Use sempre esta constante para manter o mesmo grid em toda a plataforma. */
export const PAGE_CONTAINER = "mx-auto w-full max-w-[1400px] px-4 lg:px-5";

export function PageContainer({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return <div className={cn(PAGE_CONTAINER, className)}>{children}</div>;
}

export default PageContainer;
